import { render, staticRenderFns } from "./VolunteerApplicationForm.vue?vue&type=template&id=254c775a&scoped=true"
import script from "./VolunteerApplicationForm.vue?vue&type=script&lang=js"
export * from "./VolunteerApplicationForm.vue?vue&type=script&lang=js"
import style0 from "./VolunteerApplicationForm.vue?vue&type=style&index=0&id=254c775a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c775a",
  null
  
)

export default component.exports